import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class HorizontalTabularDayTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 1100.0;
        const geometryHeightRatio = geometry.height / 650.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const bigHeight = 250 * geometryHeightRatio * dimentionsRatio;
        const smallWidth = 100 * geometryWidthRatio * dimentionsRatio;
        const bigWidth = 1000 * geometryWidthRatio * dimentionsRatio;

        const elementsMarginPosX = 50 * geometryWidthRatio * dimentionsRatio;
        const elementsPosX = geometry.drawPositionX + elementsMarginPosX;
        
        const elementsMarginPosY = 50 * geometryHeightRatio * dimentionsRatio;
        const descriptionPosY = geometry.drawPositionY + elementsMarginPosY;
        let tableElementPosY = geometry.drawPositionY + 350 * geometryHeightRatio * dimentionsRatio;
        
        const componentSecundaryColor = "#EBF5FA";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;
        
        const colElements = [];
        let i;
        for (i = 0; i < 3; i++) {
            let j;
            for (j = 0; j < 7; j++) {
                colElements.push(
                    <Rect key={`${i}-${j}`}
                        x={elementsPosX + smallWidth * j + elementsMarginPosX * j}
                        y={tableElementPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                );

            }

            tableElementPosY += smallHeight + elementsMarginPosY;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={bigWidth}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    {colElements}
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/HorizontalTabularDayTimesheetComponentCanvas.js